<template>
	<div>
		<personal-profile-data-view
			:editable="editable && !limitedEdition"
			:personal-data="formData.personalData"
			@edition-status="personalDataEditionStatus"
		></personal-profile-data-view>

		<address-profile-data-view
			:editable="editable && !limitedEdition"
			:address-data="formData.addressData"
			@edition-status="addressDataEditionStatus"
		></address-profile-data-view>

		<education-profile-data-view
			:editable="editable && !limitedEdition"
			:education-data="formData.educationData"
			@edition-status="educationDataEditionStatus"
		></education-profile-data-view>

		<interests-profile-data-view
			:editable="editable && !limitedEdition"
			:interests-data="formData.interestsData"
			@edition-status="interestsDataEditionStatus"
		></interests-profile-data-view>

		<other-profile-data-view
			:editable="editable && !limitedEdition"
			:other-data="formData.otherData"
			@edition-status="otherDataEditionStatus"
		></other-profile-data-view>

		<hidden-profile-data-view
			v-show="formData.hiddenData && hiddenDataAccessible"
			:editable="editable"
			:hidden-data="formData.hiddenData"
			@edition-status="hiddenDataEditionStatus"
		></hidden-profile-data-view>

		<v-layout row class="mb-4">
			<v-flex xs3/>
			<v-flex xs5>
				<v-alert
					:value="showAlert"
					type="info"
					outline
				>{{alertMessage}}
				</v-alert>
			</v-flex>
		</v-layout>

		<v-layout row v-if="editable">
			<v-flex xs4/>
			<v-flex xs3>
				<v-btn block color="primary" dark class="mt-2 mb-5" @click="save">Zapisz zmiany</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import {Profile} from "../../../../api/generated/Profile";
	import PersonalProfileDataView from "./components/PersonalProfileDataView";
	import AddressProfileDataView from "./components/AddressProfileDataView";
	import EducationProfileDataView from "./components/EducationProfileDataView";
	import InterestsProfileDataView from "./components/InterestsProfileDataView";
	import OtherProfileDataView from "./components/OtherProfileDataView";
	import HiddenProfileDataView from "./components/HiddenProfileDataView";

	export default {
		name: "VolunteerProfileView",
		components: {
			HiddenProfileDataView,
			OtherProfileDataView,
			InterestsProfileDataView,
			EducationProfileDataView,
			AddressProfileDataView,
			PersonalProfileDataView
		},

		data () {
			return {
				formData: {},
				personalDataEditable: false,
				addressDataEditable: false,
				educationDataEditable: false,
				interestsDataEditable: false,
				otherDataEditable: false,
				hiddenDataEditable: false,
				showAlert: false,
				alertMessage: ''
			};
		},

		computed: {
			hiddenDataAccessible () {
				return this.roles.isAdministrator() || this.roles.isLocalAdministrator() || this.roles.isDepartmentEmployee();
			}
		},

		methods: {
			personalDataEditionStatus (status) {
				this.personalDataEditable = status;
			},

			addressDataEditionStatus (status) {
				this.addressDataEditable = status;
			},

			educationDataEditionStatus (status) {
				this.educationDataEditable = status;
			},

			interestsDataEditionStatus (status) {
				this.interestsDataEditable = status;
			},

			otherDataEditionStatus (status) {
				this.otherDataEditable = status;
			},

			hiddenDataEditionStatus (status) {
				this.hiddenDataEditable = status;
			},

			save () {
				if (this.personalDataEditable || this.addressDataEditable || this.educationDataEditable ||
					this.interestsDataEditable || this.otherDataEditable || this.hiddenDataEditable) {
					this.alertMessage = 'Aby zapisać zmiany, skończ edycję danych!';
					this.showAlert = true;
				} else {
					this.showAlert = false;
					Profile.putVolunteerProfile(this, this.formData, successResponse => {
						this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane", successResponse);
						this.refresh();
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zapisać zmiany", errorResponse);
					});
				}
			},

			refresh () {
				Profile.getVolunteerProfile(this, this.$route.params.userId, successResponse => {
					this.formData = successResponse;
				}, errorResponse => {
					if (errorResponse.error === "access_denied") {
						this.$router.push("/forbidden");
					} else {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych profilowych", errorResponse);
					}
				});
			}
		},

		props: {
			editable: {
				default: false
			},
			limitedEdition: {
				default: false
			}
		},

		created () {
			this.refresh();
		},
	};
</script>

<style scoped>

</style>
